import React from "react";

const Message: React.FC = () => {
  return (
    <svg
      width="57"
      height="53"
      viewBox="0 0 57 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 441">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.0399 0C53.3693 0 56.0684 2.69903 56.0684 6.02844V36.009C56.0684 39.3384 53.3693 42.0374 50.0399 42.0374H12.1424L1.73726 51.8305C1.07962 52.4495 0.000488281 51.9832 0.000488281 51.0801V35.4491L0.0683594 35.4571V6.02844C0.0683594 2.69902 2.76739 0 6.0968 0H50.0399Z"
          fill="url(#paint0_linear_9793_14788)"
        />
        <rect
          id="Rectangle 907"
          x="6.01562"
          y="8"
          width="44"
          height="17"
          rx="4"
          fill="white"
        />
        <rect
          id="Rectangle 905"
          x="11.0156"
          y="13"
          width="34"
          height="1.5"
          rx="0.75"
          fill="#0F2162"
        />
        <rect
          id="Rectangle 906"
          x="11.0156"
          y="19"
          width="23"
          height="1.5"
          rx="0.75"
          fill="#0F2162"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9793_14788"
          x1="37.0153"
          y1="2.48348e-07"
          x2="-1.99107"
          y2="91.7374"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAF2E6" />
          <stop offset="1" stopColor="#47CAE7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Message;
